import {getterTypes} from '@/core/constants'

export default {
	[getterTypes.COMUM.GET_PARAMETRO_SISTEMA]: (state) => state.parametrosSistema,
	[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY]: (state) => state.parametrosSistema.processoUtilizacaoProcessKey,
	[getterTypes.COMUM.GET_ORGAO_LOGADO]: (state) => state.orgaoLogado,
	[getterTypes.COMUM.GET_CURRENT_TASK]: (state) => (processKey, businessKey) => {
		return ((state.loki.bpm.process[processKey] || {})[businessKey] || {}).currentTask
	},
}
